import { createAction } from 'redux-act';

export const cleanAction = createAction<void>('CLEANUP_USER_DATA');
